import React from 'react';
import Provider from './model';
import InitialBlock from './ui/InitialBlock/InitialBlock';
import CropperModal from './ui/CropperModal/CropperModal';
import CropperModalProvider from './features/cropperModal';
import UploadProvider from './features/upload';
import InitialBlockProvider from './features/initialBlock';
import CropBlockProvider from './features/cropBlock';

const DspxCropper = ({
  file,
  croppedFile,
  initialCroppedArea,
  zoom,
  aspect,
  uploadContent,
  limits,
  fileAccept = 'image/*',
  inForm = false,
  confirmLoading = false,
  onCropOk,
  onDelete,
  hasZoom = false,
}) => {
  const { minWidth, minHeight, maxSize } = limits || {};
  const validLimits = minWidth || minHeight || maxSize ? limits : null;

  return (
    <Provider>
      <UploadProvider
        uploadContent={uploadContent}
        limits={validLimits}
        accept={fileAccept}
      >
        <InitialBlockProvider
          file={file}
          initialCroppedArea={initialCroppedArea}
          zoom={zoom}
          croppedFile={croppedFile}
          inForm={inForm}
          onDelete={onDelete}
          hasZoom={hasZoom}
        >
          <InitialBlock />
        </InitialBlockProvider>

        <CropperModalProvider
          confirmLoading={confirmLoading}
          onCropOk={onCropOk}
          inForm={inForm}
        >
          <CropBlockProvider
            aspect={aspect}
            hasZoom={hasZoom}
          >
            <CropperModal />
          </CropBlockProvider>
        </CropperModalProvider>
      </UploadProvider>
    </Provider>
  );
};

export default DspxCropper;
